<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm"
      style="height: 100%">
      <el-dialog title="" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="行政责任人" class="from-el-input-line" prop="xzzrr">
              <el-input type="type" placeholder="行政责任人" class="from-el-input" v-model.trim="ruleForm.xzzrr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="行政责任人职务" class="from-el-input-line" prop="xzzrrzw">
              <el-input type="type" placeholder="行政责任人职务" class="from-el-input" v-model.trim="ruleForm.xzzrrzw">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="行政责任人联系方式" class="from-el-input-line" prop="xzzrrlxfs">
              <el-input type="type" placeholder="行政责任人联系方式" class="from-el-input" v-model.trim="ruleForm.xzzrrlxfs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="技术责任人" class="from-el-input-line" prop="jszrr">
              <el-input type="type" placeholder="技术责任人" class="from-el-input" v-model.trim="ruleForm.jszrr">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="技术责任人职务" class="from-el-input-line" prop="jszrrzw">
              <el-input type="type" placeholder="技术责任人职务" class="from-el-input" v-model.trim="ruleForm.jszrrzw"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="技术责任人联系方式" class="from-el-input-line" prop="jszrrlxfs">
              <el-input type="type" placeholder="技术责任人联系方式" class="from-el-input" v-model.trim="ruleForm.jszrrlxfs">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="巡查责任人" class="from-el-input-line" prop="xczrr">
              <el-input type="type" placeholder="巡查责任人" class="from-el-input" v-model.trim="ruleForm.xczrr">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="巡查责任人职务" class="from-el-input-line" prop="xczrrzw">
              <el-input type="type" placeholder="巡查责任人职务" class="from-el-input" v-model.trim="ruleForm.xczrrzw">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="巡查责任人联系方式" class="from-el-input-line" prop="xczrrlxfs">
              <el-input type="type" placeholder="巡查责任人联系方式" class="from-el-input" v-model.trim="ruleForm.xczrrlxfs">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round type="primary" @click="deteRmine('ruleForm')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    updateZrrInfo
  } from "@/api/api";

  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        ruleForm: {
          xzzrr: '',
          xzzrrzw: '',
          xzzrrlxfs: '',
          jszrr: '',
          jszrrzw: '',
          jszrrlxfs: '',
          xczrr: '',
          xczrrzw: '',
          xczrrlxfs: '',
        },
        rules: {
          xzzrr: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
          ],
          xzzrrzw: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
          ],
          xzzrrlxfs: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
          ],
          jszrr: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
          jszrrzw: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
          jszrrlxfs: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
          xczrr: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
          xczrrzw: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
          xczrrlxfs: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }, ],
        },
        row: null,
      };
    },
    created() {
      //初始化数据
    },
    components: {},
    methods: {
      cancel() {
      },
      deteRmine(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              ydbXzzrr: this.ruleForm.xzzrr,
              ydbXzzrrzw: this.ruleForm.xzzrrzw,
              ydbXzzrrlxfs: this.ruleForm.xzzrrlxfs,
              ydbJszrr: this.ruleForm.jszrr,
              ydbJszrrzw: this.ruleForm.jszrrzw,
              ydbJszrrlxfs: this.ruleForm.jszrrlxfs,
              ydbXczrr: this.ruleForm.xczrr,
              ydbXczrrzw: this.ruleForm.xczrrzw,
              ydbXczrrlxfs: this.ruleForm.xczrrlxfs,
              id: this.row.id,
              ydbCode: this.row.ydbCode
            }
            updateZrrInfo(params).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.message,
                  type: 'success'
                })
                this.dialogVisible = false
                this.$emit('bjadddata', {
                  dialogVisible: this.dialogVisible
                })
              } else {
                this.$notify({
                  title: '提示',
                  message: res.message,
                  type: 'success'
                })
              }
            })
          } else {
            this.$notify({
              title: '提示',
              message: '请填写完整后再提交',
              type: 'warning'
            })
            return false
          }
        })

      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleNodeClick() {
      },
    },
    mounted() {
      this.row = this.mystate[0];
      console.log(this.row);
      this.ruleForm.xzzrr = this.row.ydbXzzrr;
      this.ruleForm.xzzrrzw = this.row.ydbXzzrrzw;
      this.ruleForm.xzzrrlxfs = this.row.ydbXzzrrlxfs;
      this.ruleForm.jszrr = this.row.ydbJszrr;
      this.ruleForm.jszrrzw = this.row.ydbJszrrzw;
      this.ruleForm.jszrrlxfs = this.row.ydbJszrrlxfs;
      this.ruleForm.xczrr = this.row.ydbXczrr;
      this.ruleForm.xczrrzw = this.row.ydbXczrrzw;
      this.ruleForm.xczrrlxfs = this.row.ydbXczrrlxfs;
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 700px;
  }

  >>>.el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }
</style>
